import React from "react";
import { TContentHubSeriesDetailsProps } from "./types/ContentHubSeriesDetails.type";
import MobileSeriesDetails from "./components/MobileSeriesDetails";
import useMediaQuery from "../../lib/custom-hooks/useMediaQuery";
import DesktopSeriesDetails from "./components/DesktopSeriesDetails";
import "./styles.scss";

const ContentHubSeriesDetails = (props: TContentHubSeriesDetailsProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  if (isMobile) {
    return <MobileSeriesDetails {...props} />;
  } else {
    return <DesktopSeriesDetails {...props} />;
  }
};

export default ContentHubSeriesDetails;
